angular.module('gym.pos').factory('Sales', ["Restangular", "$rootScope", function(Restangular, $rootScope) {
  var params;
  params = $rootScope.toParams;
  return Restangular.one('gyms', params.gymId).all('pos').all('sales');
}]);
